import { IconButton, IconButtonProps } from '@mui/material'
import { ReactNode } from 'react'

interface Props extends IconButtonProps {
    icon: ReactNode
    className?: string
}
const CustomIconButton = ({ icon, className, ...restOfProps }: Props) => {
    return (
        <IconButton
            className={`-:text-primary ${className}`}
            {...restOfProps}
        >
            {icon}
        </IconButton>
    )
}

export default CustomIconButton
